<div class="titleBar">
      <img style="padding-right:20px" src="assets/images/logo.svg" alt="logo knf"/>
      <div class="title">WNIOSKI RPKIP</div>
      <div style="min-width: 256px">
            <span *ngIf="authService.isAuthenticated()" class="sessionCounter" [ngClass]="{'error' : sessionWarn}">do końca sesji: <strong>{{timeLeft}}</strong></span>&nbsp;&nbsp;
            <button pButton pRipple type="button" *ngIf="authService.isAuthenticated() && sessionWarn" icon="pi pi-stopwatch" class="p-button-outlined p-button-danger" label="Przedłuż sesję" (click)="extendSession()"></button>&nbsp;
            <p-splitButton *ngIf="authService.isAuthenticated()"
                           label="{{authService.getJwtData()?.userData?.firstName}} {{authService.getJwtData()?.userData?.familyName}}"
                           icon="pi pi-user"
                           styleClass="p-button-outlined"
                           [model]="items">
            </p-splitButton>
      </div>
</div>

<router-outlet></router-outlet>

<br/>

<p-toast></p-toast>
<p-dialog header="{{sessionExpired ? 'Sesja wygasła' : 'Zbliża się koniec sesji'}}"
          [(visible)]="displaySessionPopup"
          [modal]="true"
          [draggable]="false"
          [resizable]="false"
          [closable]="false"
          [style]="{width: '50vw'}">
      {{sessionExpired ?
        "Z powodu nieaktywności nastąpiło automatyczne wylogowanie.\nZostaniesz przekierowany/a na stronę startową" :
      "Za mniej niż minutę zostaniesz wylogowany/a.\nCzy chcesz przedłużyć sesję?"}}
      <ng-template pTemplate="footer">
            <p-button icon="{{sessionExpired ? null : 'pi pi-stopwatch'}}" label="{{sessionExpired ? 'OK' : 'Przedłuż sesję'}}" (click)="onDialogClosed()"></p-button>
      </ng-template>
</p-dialog>

